var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBxPlusCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.58334 4.08594H6.41667V6.41927H4.08334V7.58594H6.41667V9.91927H7.58334V7.58594H9.91667V6.41927H7.58334V4.08594Z",
    fill: "#22C55E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 1.16406C3.7835 1.16406 1.16666 3.7809 1.16666 6.9974C1.16666 10.2139 3.7835 12.8307 7 12.8307C10.2165 12.8307 12.8333 10.2139 12.8333 6.9974C12.8333 3.7809 10.2165 1.16406 7 1.16406ZM7 11.6641C4.42691 11.6641 2.33333 9.57048 2.33333 6.9974C2.33333 4.42431 4.42691 2.33073 7 2.33073C9.57308 2.33073 11.6667 4.42431 11.6667 6.9974C11.6667 9.57048 9.57308 11.6641 7 11.6641Z",
    fill: "#22C55E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBxPlusCircle);
export default __webpack_public_path__ + "static/media/bx-plus-circle.bb0b452a537b4c32f674216b4ee27496.svg";
export { ForwardRef as ReactComponent };